export var ACTION;
(function (ACTION) {
    ACTION["PLEDGE_CONFIRMATION"] = "PLEDGE_CONFIRMATION";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["NAV_TO_FAQ"] = "NAV_TO_FAQ";
    ACTION["SEND_OTP_FOR_PLEDGE_CONFIRM"] = "SEND_OTP_FOR_PLEDGE_CONFIRM";
    ACTION["ON_PAGE_LOAD"] = "ON_PAGE_LOAD";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["GO_TO_KFS"] = "GO_TO_KFS";
    ACTION["GO_TO_STATE_SELECTION_PAGE"] = "GO_TO_STATE_SELECTION_PAGE";
    ACTION["CHECK_REFRESH_CRITERIA"] = "CHECK_REFRESH_CRITERIA";
    ACTION["ACTIVATE_PLEDGE"] = "ACTIVATE_PLEDGE";
    ACTION["TRACK_CUSTOMER"] = "TRACK_CUSTOMER";
})(ACTION || (ACTION = {}));
